import {Component, OnInit} from '@angular/core';
import { NgbCarouselConfig} from '@ng-bootstrap/ng-bootstrap';
import {NewsStore} from '../../core/services/news/news.store';
import {NewsService} from '../../core/services/news/news.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  providers: [NgbCarouselConfig]
})

export class CarouselComponent implements OnInit {

  ngOnInit(): void {
    this.newsService.getData()
      .subscribe(
        res => {},
        err => console.log('Errore in News: ', err),
        () => { }
      );
    }

  constructor(public newsStore: NewsStore,
              private newsService: NewsService, config: NgbCarouselConfig) {
    // customize carousel configuration
    config.interval = 0;
    config.wrap = true;
    config.keyboard = false;
    config.pauseOnHover = true;
    config.showNavigationArrows = true;
    config.showNavigationIndicators = true;
  }


}
